import * as contentModalActions from './actions';
import ContentModal from './ContentModal';

export default ContentModal;
export { contentModalActions };
